<div class="box-content rd-widget widget-{{widgetConfig.widgetId}} widgetPropertyDetails widgetNoTopBorder" *ngIf="widgetData">
  <table class="widget-flex" style="height: 100%;" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-flex">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>

    <tbody>
      <tr class="light-grey-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'reportValuationPropertyName'" [align]="'left'"></widget-label></td>
        <td colspan="10"><widget-value [align]="'right'">{{widgetData.reportValuationPropertyName}}</widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'address'" [align]="'left'"></widget-label></td>
        <td colspan="10"><widget-value [align]="'right'">{{widgetData.address}}</widget-value></td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelGisCoordinates'" [align]="'left'"></widget-label></td>
        <td colspan="10"><widget-value [align]="'right'">{{widgetData.propertyLatitude | rdLocalizedNumber:5}}, {{widgetData.propertyLongitude | rdLocalizedNumber:5}}</widget-value></td>
      </tr>
    </tbody>
  </table>
</div>
